import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { InputTextarea } from 'primereact/inputtextarea';

import { updateSettingsAction } from '../../actions/settings.action';
import { ContainerTemplate } from '../../components/core-components/templates/container.template';
import { updateSocialFacebook } from '../../slices/settings.slice';
import { useAppDispatch, useAppSelector } from '../../store/store';

export const SocialFacebookPage = () => {
  const dispatch = useAppDispatch();

  const { social_facebook } = useAppSelector((store) => store.settings.list);

  const handleChange = (v: string) => {
    dispatch(updateSocialFacebook(v));
  };

  const handleSave = async () => {
    await dispatch(updateSettingsAction({ key: 'social_facebook', value: social_facebook }));
  };

  return (
    <ContainerTemplate>
      <Card title="Facebook" className={'border-2 border-yellow'}>
        <div>
          <InputTextarea
            className={'w-full'}
            id="headline"
            value={social_facebook ?? ''}
            onChange={({ target }) => handleChange(target.value)}
          />
        </div>
        <Button label="Сохранить" icon="pi pi-check" className={'mt-2'} onClick={handleSave} />
      </Card>
    </ContainerTemplate>
  );
};
